<!--
2022-10-12 HHY create
-->
<template>
  <div class="supportPage">
    <TopBack :title='$t("lang.menu.Support")'/>
    <div class="tabContainer">
      <div class="row">
        <div class="caption">
          <span>{{ $t('lang.menu.FindUs') }}</span>
        </div>
        <div class="customRow" @click="findUs">
          <div class="line" style="border: none">
            <div class="left">
              <img :src="imgList['support1']" alt=""/>
            </div>
            <div class="right"><img :src="imgList['next']" alt=""/></div>
          </div>
        </div>
        <div class="caption">
          <span>{{ $t('lang.support.followUs') }}</span>
        </div>
        <div class="customRow">
          <div class="line" @click="socialHref('https://www.whatsapp.com/channel/0029VaMerIl8vd1K7xvJWl15')">
            <div class="left">
              <img :src="imgList['support2']" alt=""/>
            </div>
            <div class="right"><img :src="imgList['next']" alt=""/></div>
          </div>
          <div class="line" @click="socialHref('https://www.facebook.com/PGEbet/')">
            <div class="left">
              <img :src="imgList['support3']" alt=""/>
            </div>
            <div class="right"><img :src="imgList['next']" alt=""/></div>
          </div>
          <div class="line" @click="socialHref('https://t.me/PGEbet555')"  style="border: none">
            <div class="left">
              <img :src="imgList['support4']" alt=""/>
            </div>
            <div class="right"><img :src="imgList['next']" alt=""/></div>
          </div>
<!--          等ins账号-->
<!--          <div class="line" style="border: none">
            <div class="left">
              <img :src="imgList['support5']" alt=""/>
            </div>
            <div class="right"><img :src="imgList['next']" alt=""/></div>
          </div>-->
        </div>
      </div>
      <div class="row">
        <div class="caption">
          <span>{{ $t('lang.support.helpNSupport') }}</span>
        </div>
        <div class="customRow">
          <div class="line" style="padding: 0 3.75vw 0 4vw;" @click="goworkOrderReview">
            <div class="left">
              <img :src="imgList['support8']" alt=""/>
              <span>{{ $t('lang.support.workOrderReview') }}</span>
            </div>
            <div v-if="workOrderMessageCount!==0" class="workOrderRedIcon">{{ workOrderMessageCount }}</div>
            <div v-else class="right"><img :src="imgList['next']" alt=""/></div>
          </div>
          <div class="line" style="padding: 0 3.75vw 0 4vw;" @click="gotoFaq">
            <div class="left">
              <img :src="imgList['support6']" alt=""/>
              <span>{{ $t('lang.support.FAQ') }}</span>
            </div>
            <div class="right"><img :src="imgList['next']" alt=""/></div>
          </div>
          <div class="line" style="border: none;padding: 0 3.5vw 0 4vw;">
            <div class="left">
              <img :src="imgList['support7']" alt=""/>
              <span>{{ $t('lang.support.supportEmail') }}</span>
            </div>
            <div class="right" @click="copy"><img :src="imgList['copy']" style="height:4vw" alt=""/></div>
          </div>
        </div>
      </div>
      <div class="submit" @click="handelOpenChat">{{ $t('lang.support.customerService') }}</div>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import {Toast} from 'mint-ui'
import request from '@/service'
const context = require.context('@/assets/images/support', true, /\.png$/)
const imgList = {}
context.keys().forEach((key) => {
  imgList[key.replace('./', '').replace('.png', '')] = context(key)
})
export default {
  name: 'Support',
  data () {
    return {
      imgList,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      workOrderMessageCount: 0
    }
  },
  components: {
    TopBack
  },
  mounted () {
    this.getMessageCount()
  },
  methods: {
    getMessageCount () {
      if (!localStorage.getItem('userInfo')) {
        return
      }
      let url = 'innovation/ticket/unread/message/count'
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).UserId
      }
      request('post', url, data, false).then(res => {
        if (res) {
          this.workOrderMessageCount = res.Count
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handelOpenChat () {
      if (this.userInfo && this.userInfo.UserShowId) {
        window.LiveChatWidget.call('set_customer_name', this.userInfo.UserShowId)
      } else {
        window.LiveChatWidget.call('set_customer_name', ' ')
      }
      window.LiveChatWidget.call('maximize')
    },
    findUs () {
      let end = ''
      if (localStorage.getItem('apkV') && localStorage.getItem('cid')) {
        end = '?cid=' + localStorage.getItem('cid') + '&v=' + localStorage.getItem('apkV')
      } else if (localStorage.getItem('apkV') && !localStorage.getItem('cid')) {
        end = '?v=' + localStorage.getItem('apkV')
      } else if (!localStorage.getItem('apkV') && localStorage.getItem('cid')) {
        end = '?cid=' + localStorage.getItem('cid')
      }
      if (window.Android) {
        end = end + '&a=true'
        window.location.href = 'https://www.pgebet.net' + end
      } else {
        end = end + '&a=false'
        window.open('https://www.pgebet.net' + end)
      }
    },
    copy () {
      navigator.clipboard.writeText(this.$t('lang.support.supportEmail'))
      Toast(this.$t('lang.account.copySuccess'))
    },
    goworkOrderReview () {
      if (this.userInfo) {
        this.$router.push('workOrderReview')
      } else {
        this.$router.push('login')
      }
    },
    gotoFaq () {
      this.$router.push('/FAQ')
    },
    socialHref (href) {
      window.open(href)
    }
  }
}
</script>
<style>
#viewContainer{
  overflow: hidden;
}
</style>
<style lang="less" scoped>

  .supportPage {
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 56px 0 70px 0;
    overflow: auto;
    .tabContainer {
      flex: 1;
      margin-top: 5vw;
      height: max-content;

      .caption {
        font-family: Inter;
        font-size: 4.722vw;
        font-weight: 600;
        text-align: left;
        color: #ECE7E0;
        margin-left: 4.861vw;
      }
      .row {
        .customRow {
          width: 90.277vw;
          height: max-content;
          margin: 3vw auto;
          background-color: rgba(217, 217, 217, 0.13);
          border-radius: 10px;
          .workOrderRedIcon{
            height: 4.444vw;
            width: 4.444vw;
            background-color: #F23042;
            border-radius: 3vw;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 2.638vw;
            font-weight: 700;
          }
          .line {
            width: 100%;
            height: 12.5vw;
            display: flex;
            padding: 0 3.75vw;
            justify-content: space-between;
            align-items: center;
            border-bottom: 0.278vw solid #3A3A3A
          }

          .left {
            display: flex;
            align-items: center;

            span {
              margin-left: 3.8vw;
              font-family: Arial;
              font-size: 4.444vw;
              font-weight: 400;
              line-height: 18.4px;
              text-align: left;
              color: #FFFFFF;
            }

            img {
              height: 5.372vw;
            }
          }

          .right {
            height: 5.372vw;

            img {
              height: 3.05vw;
            }
          }
        }
      }

      .submit {
        margin:6.5vw auto;
        background: #F6D9AA;
        color: #000D2E;
        font-size: 4.7222vw;
        border-radius: 1.111vw;
        height: 10.556vw;
        width: 72.778VW;
        display: flex;
        font-weight: 400;
        justify-content: center;
        align-items: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Support/index.vue